export enum AuditEntryState {
  EntityAdded = 'EntityAdded',
  EntityDeleted = 'EntityDeleted',
  EntityModified = 'EntityModified',
  EntitySoftAdded = 'EntitySoftAdded',
  EntitySoftDeleted = 'EntitySoftDeleted',
  RelationshipAdded = 'RelationshipAdded',
  RelationshipDeleted = 'RelationshipDeleted',
  EntityCurrent = 'EntityCurrent'
}
